import script from "./play-button.vue?vue&type=script&setup=true&lang=ts"
export * from "./play-button.vue?vue&type=script&setup=true&lang=ts"

import "./play-button.vue?vue&type=style&index=0&id=1282b9ee&lang=scss"

const __exports__ = script;

export default __exports__